<template>
	<div class="myProfile">
	    <div class="o-main-content-area">
	        <!-- Heading Section -->
	        <div class="row c-responsive-fixwidth">
	            <div class="col-md-5">
	                <p class="u-back"><a href="javascript: void(0)" @click="backToHome()"><i class="fa fa-chevron-left"></i>{{ $t('back') }}</a></p>
	            </div>
	            <div class="col-md-7 text-right">
	                <ul class="o-filter-area">
	                    <li><a href="javascript: void(0)" @click="editEmployee()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i>{{ $t('edit_profile') }}</a></li>
	                   
	                </ul>
	            </div>
            </div>
            <div class="row c-responsive-fixwidth">
	            <!-- <div class="col-md-7 c-user"> -->
	            <div class="col-md-7 c-user">
                    <div class="employee-summary-profile employee-summary-profile--inline">
                        <div class="c-user__profile-pic u-mar-right-10">
                            <img v-if="userImage.image != '' && userImage.image != 'NULL'" :src="(userImage.image)" />
                            <img v-if="userImage.image == '' || userImage.image == 'NULL'" src="static/assets/images/user1.png" />

                        </div>
                        <div class="summary-info o-schedule-user">
                        <h4 class="h1 user-name-camel">
                                <!-- {{detailEmployee.employable ?detailEmployee.employable.first_name +' '+detailEmployee.employable.last_name:"NA"}} -->
                                {{detailEmployee.employable ? (detailEmployee.employable.first_name+" "+detailEmployee.employable.last_name): "NA"}} {{detailEmployee.employable && detailEmployee.employable.display_name && detailEmployee.employable.display_name != 'null' ? '(' + (detailEmployee.employable.display_name) + ')': ""}}
                            </h4>

                            <div>
                                <p v-if="employeePhone.length > 0">
                                    <span v-for="(phone,index) in employeePhone" :key="index" v-if="phone.phone_number && phone.phone_number != '' && phone.phone_number !='0'">
                                        <span v-if="phone.label && (phone.label=='Home phone' || 'Home Phone' || 'Cell phone' || 'Cell Phone')">
                                            {{ $t(phone.label) }}:
                                        </span> 
                                        <span v-else>{{ phone.label }}:</span>
                                        <!-- <span class="header-value">{{ phone.phone_number }}</span> -->
                                        <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="header-value phone-number-display">
                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }},
                                        </a>
                                    </span>
                                </p>
                                <p v-else>
                                    <span>{{ $t('home_phone') }}:</span><span class="header-value">NA</span>
                                    <span>{{ $t('cell_phone') }}:</span><span class="header-value">NA</span>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <span>Status:</span>
                                    <span class="header-value">{{ detailEmployee.employee_status?detailEmployee.employee_status.name:'NA' }},</span>
                                    <span>Seniority:</span>
                                    <span class="header-value">{{ detailEmployee.seniority?detailEmployee.seniority:'NA' }},</span>
                                    <span>{{ $t('account_type') }}: {{detailEmployee ?detailEmployee.employable_type:"NA"}}</span>
                                </p>                            
                            </div>
                        </div>
                    </div>
	                    <!-- <p>{{ $t('account_type') }}: {{detailEmployee ?detailEmployee.employable_type:"NA"}}</p> -->
	            </div>
	        </div>
        </div>
	    <div class="clearfix"></div>
	        <!-- /Heading Section -->
	        <!-- Main Body Content area -->
	        <!-- Tab nav area -->
        <div class="ml-30">
            <div class="c-common-space c-responsive-fixwidth">
                <div class="o-tab-area clearfix">
                    <div class="col-md-12 o-no-padding">
                        <ul class="o-tab-view o-tab-view--text">
                            <li><a href="javascript: void(0)" :class="{active :(tab=='basic')?true:false}" @click="changeTab('basic')">{{ $t('basic_information') }}</a></li>
                            <li v-if="disabledFrelenceUser()"><a href="javascript: void(0)" :class="{active :(tab=='skill')?true:false}" @click="changeTab('skill')">{{$t('skillset')}}</a></li>
                            <li><a href="javascript: void(0)" :class="{active :(tab=='vacation')?true:false}" @click="changeTab('vacation')"> {{ $t('unavailability') + " & " + $t('vacation') }}</a></li>
                            <li v-if="checkAccess(detailEmployee.notes_documents) && disabledFrelenceUser()"><a href="javascript: void(0)" :class="{active :(tab=='notes')?true:false}" @click="changeTab('notes')">{{ $t('notes_and_documents') }}</a></li>
                            <li><a :class="{active :(tab=='emergency')?true:false}" @click="changeTab('emergency')">Emergency </a></li>
                            <li  v-if="disabledFrelenceUser()"><a href="javascript: void(0)" :class="{active :(tab=='settings')?true:false}" @click="changeTab('settings')">{{ $t('settings') }}</a></li>
                        
                        </ul>
                    </div>
                </div>
            </div>
                <!-- /Tab nav area -->
                <!-- Tab content area -->
            <basicInfo :userProfile="detailEmployee" v-if="tab=='basic'"/>
            <skills :userProfile="detailEmployee" v-if="tab=='skill'"/>
            <availability :userProfile="detailEmployee" v-if="tab=='vacation'"/>
            <notes :userProfile="detailEmployee" v-if="tab=='notes'"/>
            <emergency :userProfile="detailEmployee" v-if="tab=='emergency'"/>
            <settings :userProfile="detailEmployee" v-if="tab=='settings'" />
        </div>
	        <!-- /Tab content area -->
	</div>
</template>
<script>
    import basicInfo from './basicInfo';
    import skills from './skills';
    import availability from './availability';
    import emergency from './emergency';
    import notes from './notes';
    import settings from './settings';
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    import { bus } from '../../main';
    import { global } from '../../global.js';
    import service from '../../services.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                userRoleSlug: 'userRoleSlug'
            })
        },
        components: {
            'basicInfo': basicInfo,
            'skills': skills,
            'availability': availability,
            'emergency': emergency,
            'notes': notes,
            'settings': settings,
        },
        data() {
            return {
                tab: "basic",
                userImage: "",
                detailEmployee: {
                    notes_documents:'disabled',
                },
                getBaseURL: '',
                employeePhone: []
            }
        },
        methods: {
            disabledFrelenceUser(){
                return dateTimeConvert.disabledFrelenceUser();
            },
            checkAccess(status){
                var user = dateTimeConvert.getCookie('csLogin');
                // console.log(user);
                if(this.userRoleSlug != 'client-admin' && this.userRoleSlug != 'power-user' && status == 'disabled')
                    return false;
                else
                    return true;
            },
            editEmployee() {
                let dispatchData = {
                    'id': this.detailEmployee.id,
                    'name': this.detailEmployee.employable.first_name + ' ' + this.detailEmployee.employable.last_name,
                    'type': this.detailEmployee.employable_type
                };

                //this.$store.dispatch('selectEmployee', dispatchData);
                this.$store.dispatch('setEditEmployeesFrom', 'editMyProfile');
                this.$store.dispatch('setEditUserTab', 'personal');
                this.$router.push({
                    'path': '/editEmployee/'+btoa(this.detailEmployee.id)
                });
            },
            changeTab: function(newTab) {
                this.tab = newTab;
            },
            backToHome() {
                this.$router.push({
                    path: `/jobList`
                });
            },
            getEmpDetails() {
                this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                service.get('employee/' + this.employeeId, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.detailEmployee = res.data.result;
                        this.userImage = this.detailEmployee.employable;
                        this.employeePhone=res.data.result.employable?res.data.result.employable.phones:[];
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            }
        },
        beforeMount() {
            this.getEmpDetails();
            bus.$on('onProfileUpdateOrAdd', (data) => {
                //this.personalInfo = data;
                //console.log("Emit fire..", data);
                this.getEmpDetails();
            });
        },

    }

</script>

<style scoped>
.ml-30 {
    margin-left: 30px;
}
.employee-summary-profile--inline {
    display: flex!important;
}
.header-value{
    color: #000!important;
    text-transform: capitalize;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
</style>
